import { ResourceModel } from './resource.model';
import { ResourceType } from '../../helpers/Const';

export class ResourceGroupModel extends ResourceModel {
    constructor(init?: Partial<ResourceGroupModel>) {
        super();
        Object.assign(this, init);
        this.type = ResourceType.RESOURCE_GROUP;
    }
}
